import Vue from 'vue';

import HTTPService from '@/services/Http';

import store from '@/store';
import router from '@/router';
import { LOGIN } from '@/router/const';

import capustaAlert from '@/plugins/capusta_alert/alert';

Vue.use(capustaAlert);

export default {
  user: {
    authenticated: false,
  },

  authByToken(token) {
    store.commit('CLEAR_ALL_STATE');
    localStorage.setItem('token', token);

    this.user.authenticated = true;

    if (localStorage.getItem('redirect')) {
      router.push(localStorage.getItem('redirect'));
    } else {
      router.push({ name: 'cabinet' });
    }
  },

  // eslint-disable-next-line complexity
  async login(user) {
    try {
      const { data } = await HTTPService.auth(user);
      localStorage.removeItem('blocked');

      if (data.status && data.status !== 'PENDING') {
        store.commit('CLEAR_ALL_STATE');
        localStorage.setItem('token', data.token);

        this.user.authenticated = true;
      }

      return data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  logout() {
    store.commit('CLEAR_ALL_STATE');
    localStorage.removeItem('token');

    this.user.authenticated = false;

    router.push({ name: LOGIN });
  },

  async refreshToken(token) {
    localStorage.setItem('token', token);

    this.user.authenticated = true;
  },

  checkAuth() {
    if (localStorage.getItem('token')) {
      this.user.authenticated = true;
    } else {
      this.user.authenticated = false;
    }

    return this.user.authenticated;
  },
};
